import React, { useEffect, useRef, useState } from 'react';
import BarraLateral from '../Componentes/BarraLateral';
import HeaderNavegacao from '../Componentes/HeaderNavegacao';
import fundo from '../Imagens/Ativo 3.png';
import '../Estilos/Container.css';
import { useNavigate } from 'react-router-dom';
import LoaderComponent from './LoaderComponent';

export default function CorpoPagina(props) {
  const ref = useRef(null);
  const [altura, setAltura] = useState(0);
  const Navega = useNavigate();
  const [headerHamburguerStatus, setHeaderHamburguerStatus] = useState(false);

  useEffect(() => {
    let newAltura = altura;
    if (ref.current.scrollHeight && altura < ref.current.scrollHeight - 80) {
      newAltura = ref.current.scrollHeight - 80;
    } else if (altura < ref.current.innerHeight - 80) {
      newAltura = ref.current.innerHeight - 80;
    }

    if (newAltura !== altura) {
      setAltura(newAltura);
    }
  }, [altura]);

  const changePageDireita = () => {
    Navega(props.paginaDireita);
  };

  const changePageEsquerda = () => {
    Navega(props.paginaEsquerda);
  };

  return (
    <div className={'BoasVindasCorpo'} ref={ref}>
      <HeaderNavegacao
        menuHamburguerEvent={(status) => {
          setHeaderHamburguerStatus(status);
        }}
      />

      <div
        style={{
          width: '100vw',
          alignSelf: 'stretch',
          display: 'flex',
          flexDirection: 'row',
          backgroundImage: props.wellcome ? `url(${fundo})` : null,
          backgroundSize: '100%',
          backgroundRepeat: 'repeat-y',
          height: '100%',
        }}
      >
        {headerHamburguerStatus ? <BarraLateral altura={altura} /> : null}

        <div
          style={{
            display: 'flex',
            height: '100%',
            width: '100vw',
            flexDirection: 'row',
            justifyContent: 'center',
          }}
        >
          {props.seta ? (
            <img
              className="SetaEsqueda"
              src={require('../Icones/seta.png')}
              height={27}
              width={13}
              alt="Seta"
              style={{ marginTop: 480, marginRight: 16, cursor: 'pointer' }}
              onClick={() => {
                changePageEsquerda();
              }}
            />
          ) : null}

          {props.children}

          {props.seta ? (
            <img
              className="SetaDireita"
              src={require('../Icones/setaEsquerda.png')}
              height={27}
              width={13}
              alt="Seta"
              style={{ marginTop: 480, cursor: 'pointer', marginLeft: 8 }}
              onClick={() => {
                changePageDireita();
              }}
            />
          ) : null}
          <LoaderComponent visible={props.loading} altura={altura} />
        </div>
      </div>
    </div>
  );
}
